<template>
  <el-row class="h-full content_block category-list">
    <el-col :span="12" class="JZTreeContainer h-full overflow-h">
      <div style="display:flex;font-size: 18px;line-height: 40px;">
        <b style="flex:1;">商品分类</b>
        <el-link :underline="false" type="primary" style="color: #237FFA;">
          <i class="el-icon-circle-plus-outline" circle style="font-size: 14px;" @click="handleAddFirstCategory">添加一级分类</i>
        </el-link>
      </div>
      <el-input
        placeholder="输入关键字进行过滤"
        v-model.trim="filterText"
        prefix-icon="el-icon-search"
        class="margin-bottom"
      ></el-input>
      <el-tree
        :data="categoryLists"
        :props="defaultProps"
        @node-click="handleNodeClick"
        node-key="id"
        :default-expanded-keys="expandedKeys"
        :current-node-key="currentNodeKey"
        @node-expand="handleNodeExpand"
        @node-collapse="handleNodeCollapse"
        :filter-node-method="filterNode"
        ref="JZCategoryTree"
      >
        <span class="custom-tree-node" slot-scope="{ node, data }">
          <span class="custom-tree-name" :title="node.name">{{ node.label }}</span>
          <span>
            <i
              class="el-icon-circle-plus-outline"
              :class="{ active: JZCategoryInfo && JZCategoryInfo.parentId === data.id && isCurrentStatus === 3 }"
              type="text"
              size="mini"
              @click.self.stop.prevent="() => handleAddCategory(node, data)"
            ></i>
            <i
              class="el-icon-edit-outline"
              type="text"
              :class="{ active: currentNodeKey === data.id && isCurrentStatus === 2 }"
              v-if="!data.fixedFlag"
              size="mini"
              @click.self.stop.prevent="() => handleEditCategory(node, data)"
            ></i>
            <i
              class="el-icon-delete"
              type="text"
              size="mini"
              :class="{ active: currentNodeKey === data.id && isCurrentStatus === 4 }"
              v-if="!data.fixedFlag"
              @click.self.stop.prevent="() => handleDeleteCategory(node, data)"
            ></i>
          </span>
        </span>
      </el-tree>
    </el-col>
    <el-col :span="12" class="JZDetailContent">
      <el-card class="box-card" style="margin-top: 0;padding-top:0;" v-if="JZCategoryInfo">
        <div style="display:flex;font-size: 18px;line-height: 40px;">
          <b style="flex:1;">{{categoryTitle}}</b>
        </div>
        <el-descriptions :column="1" size="normal" style="padding: 0 15px;" v-if="[0, 1, 4].includes(isCurrentStatus)">
          <el-descriptions-item label="分类名称">{{ JZCategoryInfo.name || '--' }}</el-descriptions-item>
          <el-descriptions-item label="分类描述">{{ JZCategoryInfo.description || '--' }}</el-descriptions-item>
          <el-descriptions-item label="分类图标" v-if="JZCategoryInfo.image">
            <el-image style="width: 40px; height: 40px" :src="JZCategoryInfo.image" :preview-src-list='[JZCategoryInfo.image]' fit="fill"></el-image>
          </el-descriptions-item>
          <el-descriptions-item label="分类图标" v-else>
            --
          </el-descriptions-item>
          <el-descriptions-item label="排序值">{{ JZCategoryInfo.sortOrder||0}}</el-descriptions-item>
          <el-descriptions-item label="佣金比例">{{ JZCategoryInfo.commissionRate || 0}}%</el-descriptions-item>
          <el-descriptions-item label="状态">{{ JZCategoryInfo.enableFlag === true ? '启用' : JZCategoryInfo.enableFlag === false ? '禁用' : '--' }}</el-descriptions-item>
          <el-descriptions-item label="绑定品牌">
            {{ (JZCategoryInfo.brandList || []).map(i => i.name).join(',') || '--' }}<el-button type="text" style="margin-left:3px;" @click="handleEditBrand">编辑</el-button></el-descriptions-item>
          <el-descriptions-item label="绑定属性">
            <div class="ellipsisContainer" :title="(attributeLists || []).map(i => i.attributeGroupName).join(',') || '--'">
              {{ (attributeLists || []).map(i => i.attributeGroupName).join(',') || '--' }}
              <el-button type="text" style="margin-left:3px;" @click="handleEditAttribute">编辑</el-button>
            </div>
          </el-descriptions-item>
        </el-descriptions>
        <el-form
          :model="JZCategoryInfo"
          ref="JZCategoryInfoForm"
          :rules="rules"
          label-width="120px"
          label-position="right"
          style="width: 100%"
          v-else
        >
          <el-form-item label="上级分类：" prop="parentName">
            <div class="ellipsisContainer" :title="JZCategoryInfo.parentName">{{ JZCategoryInfo.parentName }}</div>
          </el-form-item>
          <el-form-item label="分类名称：" prop="name">
            <el-input v-model.trim="JZCategoryInfo.name" placeholder="请输入分类名称"></el-input>
          </el-form-item>
          <el-form-item label="分类描述：" prop="description">
            <el-input v-model.trim="JZCategoryInfo.description" placeholder="请输入分类描述" type="textarea" maxlength="50" show-word-limit></el-input>
          </el-form-item>
          <el-form-item label="分类图标：" prop="imageList">
            <upload
              v-model="JZCategoryInfo.imageList"
              label="分类图标"
              :maxSize="10"
              size="mini"
              :limit="1"
            />
          </el-form-item>
          <el-form-item label="排序值：" prop="sortOrder">
            <el-input v-model.trim="JZCategoryInfo.sortOrder" placeholder="请输入排序值"></el-input>
          </el-form-item>
          <el-form-item label="佣金比例(%)：" prop="commissionRate">
            <div style="display: flex;">
              <el-input-number type="number" style="text-align: left;flex:1;" v-model.number="JZCategoryInfo.commissionRate" controls-position="right" :precision="2" :max="100" :min="0" placeholder="请输入佣金比例(%)"></el-input-number>&nbsp;&nbsp;%
            </div>
          </el-form-item>
          <el-form-item label="状态：" prop="enableFlag">
            <el-radio-group v-model="JZCategoryInfo.enableFlag">
              <el-radio :label="true">启用</el-radio>
              <el-radio :label="false">禁用</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="[2, 3].includes(isCurrentStatus)" class="btnsContainer">
            <el-button type="default" @click="handleCancel">取消</el-button>
            <el-button type="primary" @click="saveAndUpdateCategory">确定</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </el-col>
    <EditBrand ref="JZEditBrand" @handleUpdatePage="handleUpdatePage"></EditBrand>
  </el-row>
</template>
<script>
import {getCategoryLists, addCategory, updateCategory, deleteCategory, detailCategory, getCategoryAttributeGroupPageList} from '@/api/PlatformSales/Category.js';
import Upload from '@/components/common/upload';
import EditBrand from './component/EditBrand';
export default {
  name: 'CategoryLists',
  components: {
    Upload,
    EditBrand,
  },
  props: {
    id: {
      type: String,
      default () {
        return '0';
      },
    },
    name: {
      type: String,
    },
  },
  data () {
    return {
      selectedRootId: '',
      isCurrentStatus: 0, // 状态3: 新增 2:编辑 1：查看 0:初始化状态
      categoryInfo: {},
      JZCategoryInfo: null,
      categoryLists: [],
      defaultProps: {
        children: 'children',
        label: 'name',
      },
      filterText: '',
      currentNodeKey: '',
      expandedKeys: [this.id],
      medicalId: '',
      medicalName: '',
      attributeLists: [],
    };
  },
  computed: {
    categoryTitle () {
      return (this.JZCategoryInfo.parentId === '0' ? [
        '一级分类详情',
        '一级分类详情',
        '编辑一级分类',
        '添加一级分类',
      ] : [
        '子分类详情',
        '子分类详情',
        '编辑子分类',
        '添加子分类',
      ])[this.isCurrentStatus || 0];
    },
    isdisabled () {
      return ['1', 1].includes(this.isCurrentStatus);
    },
    rules () {
      return {
        name: [
          {
            required: true,
            message: '分类名称（中文）不可为空',
            trigger: ['blur', 'change'],
          },
          {
            min: 0,
            max: 100,
            message: '分类名称（中文）不可超过100个字符',
            trigger: ['blur', 'change'],
          },
          {
            pattern: /^\S*$/g,
            message: '分类名称（中文）输入格式不可包含空格',
            trigger: ['change', 'blur'],
          },
        ],
        description: [
          {
            required: true,
            message: '分类描述不可为空',
            trigger: ['blur', 'change'],
          },
        ],
        imageList: [
          {
            required: true,
            message: '请选择分类图标',
            trigger: ['blur', 'change'],
          },
        ],
        commissionRate: [
          {
            required: true,
            message: '请输入佣金比例(%)',
            trigger: ['blur', 'change'],
          },
        ],
      };
    },
    isCurrentBtnText () {
      return this.isCurrentStatus === 2 ? '更新' : this.isCurrentStatus === 3 ? '新增' : '';
    },
  },
  watch: {
    filterText (val) {
      this.$refs.JZCategoryTree.filter(val);
    },
  },
  methods: {
    handleEditAttribute () {
      this.$router.push({
        name: 'PlatformSales_PlatformCategories_BindAttribute',
        query: {
          id: this.JZCategoryInfo.id,
        },
      });
    },
    handleEditBrand () {
      this.$refs.JZEditBrand.dialogTitle = '绑定品牌';
      this.$refs.JZEditBrand.currentId = this.JZCategoryInfo.id;
      this.$refs.JZEditBrand.initPage();
    },
    changeMedicalHandle (item) {
      this.JZCategoryInfo.medicalName = item.name;
    },
    initPageData () {
      this.isCurrentStatus = 0;
      this.filterText = '';
      if (this.currentNodeKey) {
        this.detailCategoryInfo({id: this.currentNodeKey});
      } else {
        this.detailCategoryInfo(this.categoryLists[0]);
      }
      this.$refs.JZCategoryInfoForm && this.$refs.JZCategoryInfoForm.clearValidate();
    },
    handleUpdatePage () {
      detailCategory({
        id: this.currentNodeKey,
        findParentFlag: true,
        findBrandFlag: true,
      }).then(({body}) => {
        this.selectedRootId = body.rootId;
        this.dealDetailCategoryInfo(body);
      });
    },
    filterNode (value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    handleNodeClick (categoryInfo, node) {
      // 状态1: 查看 2:编辑 3：新增
      this.isCurrentStatus = 1;
      if (node.level === 1) {
        this.detailCategoryInfo(node);
      } else {
        this.detailCategoryInfo(categoryInfo);
      }
    },
    handleDeleteCategory (node, categoryInfo) {
      this.isCurrentStatus = 4;
      this.currentNodeKey = categoryInfo.id;
      this.$confirm(`确认删除【${categoryInfo.name}】吗？`, '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        deleteCategory({ id: categoryInfo.id }).then(this.handleDeleteCategorySuccess);
      }).catch(() => {
        this.getAllCategoryLists();
      });
    },
    handleDeleteCategorySuccess () {
      this.$message.success('删除成功！');
      this.getAllCategoryLists();
    },
    handleEditCategory (node, categoryInfo) {
      this.isCurrentStatus = 2;
      // 状态1: 查看 2:编辑 3：新增
      if (node.level === 1) {
        this.detailCategoryInfo(node);
      } else {
        this.selectedRootId = categoryInfo.rootId;
        this.detailCategoryInfo(categoryInfo);
      }
    },
    // 获取分类详情
    detailCategoryInfo (node) {
      detailCategory({
        id: node?.data?.id || node.id,
        findParentFlag: true,
        findBrandFlag: true,
      }).then(({body}) => {
        this.selectedRootId = body.rootId;
        this.dealDetailCategoryInfo(body);
      });
    },
    handleAddFirstCategory () {
      this.isCurrentStatus = 3;
      this.JZCategoryInfo = {
        parentId: '0',
        parentName: '顶级分类',
        id: '',
        name: '',
        imageList: [],
        image: '',
        sortOrder: '',
        commissionRate: undefined,
        enableFlag: '',
        level: 0,
      };
      this.$nextTick(() => {
        this.$refs.JZCategoryInfoForm && this.$refs.JZCategoryInfoForm.clearValidate();
      });
    },
    handleAddCategory (node, categoryInfo) {
      // 状态1: 新增 2:编辑 3：查看
      this.isCurrentStatus = 3;
      this.detailCategoryInfo(categoryInfo);
    },
    getAllCategoryLists () {
      getCategoryLists({}).then(({body})=>{
        this.categoryLists = body || [];
        this.initPageData();
      });
    },
    handleNodeExpand (data) {
      // 保存当前展开的节点
      let flag = false;
      this.expandedKeys.some(item => {
        if (item === data.id) {
          // 判断当前节点是否存在， 存在不做处理
          flag = true;
          return true;
        }
      });
      if (!flag) {
        // 不存在则存到数组里
        this.expandedKeys.push(data.id);
      }
    },
    // 树节点关闭
    handleNodeCollapse (data) {
      this.expandedKeys.some((item, i) => {
        if (item === data.id) {
          // 删除关闭节点
          this.expandedKeys.length = i;
        }
      });
    },
    dealDetailCategoryInfo (info) {
      this.attributeLists = [];
      this.currentNodeKey = info.id;
      let currentForm = {};
      let imageList = info.image ? [
        {
          url: info.image,
          id: info.image,
          name: info.image,
        },
      ] : [];
      if ([0, 1].includes(this.isCurrentStatus)) {
        currentForm = {
          parentId: info.parentId,
          id: info.id,
          name: info.name || '',
          parentName: info.parentName || '顶级分类',
          description: info.description || '',
          imageList: imageList,
          image: info.image,
          sortOrder: info.sortOrder,
          commissionRate: info.commissionRate || 0,
          enableFlag: info.enableFlag,
          brandList: info.brandList || [],
        };
        this.getAllCategoryBrandList(info.id);
      } else if ([2].includes(this.isCurrentStatus)) {
        currentForm = {
          parentId: info.parentId,
          id: info.id || '0',
          name: info.name || '',
          parentName: info.parentName || '顶级分类',
          description: info.description || '',
          imageList: imageList,
          image: info.image,
          sortOrder: info.sortOrder,
          commissionRate: info.commissionRate || 0,
          enableFlag: info.enableFlag,
          brandList: info.brandList || [],
        };
      } else if (this.isCurrentStatus === 3) {
        currentForm = {
          parentId: info.id,
          parentName: info.name || '顶级分类',
          id: '',
          name: '',
          imageList: [],
          image: '',
          sortOrder: '',
          commissionRate: undefined,
          enableFlag: '',
        };
      }
      currentForm.level = info.level;
      this.JZCategoryInfo = currentForm;
      this.$nextTick(() => {
        this.$refs.JZCategoryInfoForm && this.$refs.JZCategoryInfoForm.clearValidate();
      });
    },
    handleCancel () {
      this.isCurrentStatus = 1;
      this.dealDetailCategoryInfo();
    },
    saveAndUpdateCategory () {
      this.$refs.JZCategoryInfoForm.validate(valid => {
        if (valid) {
          if (this.isCurrentStatus === 3) {
            let currentParams = JSON.parse(JSON.stringify(this.JZCategoryInfo));
            currentParams = {
              ...currentParams,
              image: currentParams.imageList[0].url,
            };
            addCategory(currentParams).then(this.saveAndUpdateSuccessFun);
          } else if (this.isCurrentStatus === 2) {
            let currentParams = JSON.parse(JSON.stringify(this.JZCategoryInfo));
            currentParams = {
              ...currentParams,
              image: currentParams.imageList[0].url,
            };
            updateCategory(currentParams).then(this.saveAndUpdateSuccessFun);
          }
        }
      });
    },
    saveAndUpdateSuccessFun (jsonData) {
      if (jsonData.heads.code === 200) {
        let currentMessage = this.isCurrentStatus === 3 ? '创建成功！' : '更新成功！';
        this.$message.success(currentMessage);
        this.getAllCategoryLists();
      }
    },
    getAllCategoryBrandList (id) {
      getCategoryAttributeGroupPageList({
        categoryId: id,
      }).then(({body}) => {
        this.attributeLists = body.list || [];
      });
    },
  },
  created () {
    this.getAllCategoryLists();
  },
};
</script>
<style lang="scss" scoped>
.category-list {
  display: flex;
}
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
  line-height: 32px;
  /* background: rgba(15,137,255,0.08); */
  border-radius: 4px;
  i {
    /* color: #409eff; */
    font-size: 14px;
    color: #d3d3d3;
    &.active {
      color: #5195eb;
    }
  }
  .custom-tree-name {
    max-width: 300px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
}
.JZTreeContainer {
  width: 500px;
  display: flex;
  flex-direction: column;
  border: 1px solid #dddddd;
  padding: 12px;
  border-radius: 4px;
  & > .el-tree {
    flex: 1;
    overflow: auto;
  }
  margin-right: 20px;
}
.JZDetailContent {
  background: #fff;
  flex: 1;
  // height: 800px;
  overflow-y: auto;
  border: 1px solid #dddddd;
  padding: 0;
  border-radius: 4px;
  /deep/.el-card__body{
    padding-top: 10px;
  }
  .ellipsisContainer {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    display: flex;
    align-items: center;
  }
}

.categoryInfoContainer_title {
  width: 200px;
  height: 50px;
  color: #333333;
  font-size: 18px;
  text-align: center;
  line-height: 50px;
  border: 1px solid rgba(121, 121, 121, 1);
  margin-bottom: 40px;
}
.el-tree-node.is-current {
  background: rgba(15, 137, 255, 0.08);
  border-radius: 4px;
}
/deep/.btnsContainer.el-form-item--small .el-form-item__content{
  text-align: right;
}
/deep/ .el-descriptions-item__container{
  display: flex;
  align-items: center;
  .el-descriptions-item__label{
    display: flex;
    align-items: center;
  }
  .el-descriptions-item__content{
    display: flex;
    align-items: center;
  }
  .el-tree-node.is-current {
    background: rgba(15, 137, 255, 0.08);
    border-radius: 4px;
  }

}
</style>
